import React from 'react'
import PropTypes from 'prop-types'
import glamorous from 'glamorous'
import content from 'pp-react-l10n'
import { isDw2Repaint } from 'experiments/dw2Repaint'
import { Alert, Button } from '@paypalcorp/pp-react'
import { hasGuestFlowRevamp } from '../../../experiments/guest'

let i18n = content('transfer/inc/cashAdvanceFees')

/*
 *  Styles can be overriden by using the props and pass in a css object.
 *  EX: { margin: '0 0 0 36px'; }
 */

const Label = glamorous.div(
  {
    margin: 'auto',
  },
  'ppvx_alert ppvx_alert--type_attention'
)

function renderMessageWithButtonLink(message = '', click, isGuest) {
  if (!message.includes('|')) {
    return <React.Fragment>{message}</React.Fragment>
  }

  if (isGuest) {
    const genericIssuerName = i18n('generic.issuer.name')
    message = i18n('guest.warning.label', {
      genericIssuerName,
    })
  }

  /*
   * Function is creating a button link within message not an <a href>
   * 1) Expecting a message '{|} Click here {|} for some awesome overpanel.'
   * 2) First massage to '| Click here | for some awesome overpanel.'
   * 3) What is within the 'pipe' symobl is used as text within a button component.
   * 4) Return component
   */

  const messageContent = message.replace(/{|}/g, '')
  const messageArr = messageContent.split('|')

  const handleButtonOnClick = event => {
    event.preventDefault()
    click()
  }

  return (
    <React.Fragment>
      {isDw2Repaint() || hasGuestFlowRevamp() ? (
        <>
          <Alert type="warning">
            {messageArr[0] ? messageArr[0] : null}
            <Button
              onClick={handleButtonOnClick}
              tertiary={true}
              type="button"
              style={{ padding: 0 }}
            >
              {messageArr[1]}
            </Button>
            {messageArr[2] ? messageArr[2] : null}
          </Alert>
        </>
      ) : (
        <>
          <span>{messageArr[0] ? messageArr[0] : null} </span>
          <button
            className={`vx_btn-link ppvx_text--medium`}
            onClick={handleButtonOnClick}
          >
            {messageArr[1]}
          </button>
          <span> {messageArr[2] ? messageArr[2] : null} </span>
        </>
      )}
    </React.Fragment>
  )
}

const WarningLabel = ({
  stylesOverride = {},
  messageOverride = '',
  handleOnClick = () => {},
  isGuest = false,
}) =>
  isDw2Repaint() || hasGuestFlowRevamp() ? (
    <div data-nemo="cash-advance-fee-warning-label" style={stylesOverride}>
      {renderMessageWithButtonLink(
        messageOverride ? messageOverride : i18n('warning.label'),
        handleOnClick,
        isGuest
      )}
    </div>
  ) : (
    <Label
      data-nemo="cash-advance-fee-warning-label"
      css={stylesOverride}
      role="alert"
    >
      {renderMessageWithButtonLink(
        messageOverride ? messageOverride : i18n('warning.label'),
        handleOnClick,
        isGuest
      )}
    </Label>
  )

WarningLabel.propTypes = {
  stylesOverride: PropTypes.object,
  messageOverride: PropTypes.string,
  handleOnClick: PropTypes.func,
  isGuest: PropTypes.bool,
}

export default WarningLabel
